import { PATHWAYS_JSON_CONTENT_TYPE, sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'
import type { GeneratedStrategies, SdiStrategiesRequest, StudentCharacteristic, UdlGuideline } from './sdi_types'

const sdiApiUrl = `${goalbookUrls.pathwaysApi}/sdi_generation`

const UDL_GUIDELINES: UdlGuideline[] = ['engagement', 'expression', 'representation']

let cachedCharacteristics: StudentCharacteristic[] | null = null

export function clearSdiStudentCharacteristicsCache() {
  cachedCharacteristics = null
}

// The list rarely changes, so it is fetched once per session, as Vue 2's memory cache did.
export async function getSdiStudentCharacteristics(): Promise<StudentCharacteristic[]> {
  if (cachedCharacteristics) {
    return cachedCharacteristics
  }
  try {
    const response = await sendHTTPRequest({ url: `${sdiApiUrl}/student_characteristics`, method: 'GET' })
    const body = await response.json() as { characteristics?: StudentCharacteristic[] } | null
    const characteristics = body?.characteristics
    if (!Array.isArray(characteristics)) {
      throw new Error('invalid student characteristics response')
    }
    cachedCharacteristics = characteristics
    return characteristics
  } catch (error) {
    throw new Error('Failed to get SDI student characteristics', { cause: error })
  }
}

function hasEveryGuideline(strategies: Partial<GeneratedStrategies> | null): strategies is GeneratedStrategies {
  return Boolean(strategies) && UDL_GUIDELINES.every((guideline) => Boolean(strategies?.[guideline]))
}

export async function generateSdiStrategies(request: SdiStrategiesRequest): Promise<GeneratedStrategies> {
  const response = await sendHTTPRequest({ url: `${sdiApiUrl}/goal_strategies`, method: 'POST', contentType: PATHWAYS_JSON_CONTENT_TYPE, jsonBody: request })
  const strategies = await response.json() as Partial<GeneratedStrategies> | null
  if (!hasEveryGuideline(strategies)) {
    throw new Error('invalid strategy response')
  }
  return strategies
}
